import { TableCell, TableRow } from "@egaranti/components";

import { useState } from "react";

import ReportTable from "./ReportTable";
import SortableSearchableTableDialog from "./SortableSearchableTableDialog";
import { useTranslation } from "react-i18next";

const PersonnelPerformanceTable = ({ data, loading }) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const displayData = data?.slice(0, 10) || [];

  const columns = [
    {
      key: "personnel",
      label: t("extendedWarranty.reports.personnel.name", "Personel"),
      sortable: true,
      align: "left",
    },
    {
      key: "store",
      label: t("extendedWarranty.reports.personnel.store", "Mağaza"),
      sortable: true,
      align: "left",
    },
    {
      key: "count",
      label: t("extendedWarranty.reports.personnel.count", "Adet"),
      sortable: true,
      align: "right",
    },
    {
      key: "revenue",
      label: t("extendedWarranty.reports.personnel.revenue", "Ciro"),
      sortable: true,
      align: "right",
    },
  ];

  const handleSearch = (item, query) => {
    const personnelName = (item.labels?.[0] || "").toLowerCase();
    const storeName = (item.storeName || "").toLowerCase();
    const count = (item.data?.[0] || "").toString().toLowerCase();
    const revenue = (item.totalRevenue || "").toLowerCase();

    return (
      personnelName.includes(query) ||
      storeName.includes(query) ||
      count.includes(query) ||
      revenue.includes(query)
    );
  };

  const handleSort = (a, b, key, direction) => {
    let aValue, bValue;

    switch (key) {
      case "personnel":
        aValue = a.labels?.[0] || "";
        bValue = b.labels?.[0] || "";
        return direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      case "store":
        aValue = a.storeName || "";
        bValue = b.storeName || "";
        return direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      case "count":
        aValue = a.data?.[0] || 0;
        bValue = b.data?.[0] || 0;
        break;
      case "revenue":
        aValue = parseFloat(
          a.totalRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        bValue = parseFloat(
          b.totalRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        break;
      default:
        return 0;
    }

    return direction === "asc" ? aValue - bValue : bValue - aValue;
  };

  const renderCell = (item, key) => {
    const notAvailable = t("common.notAvailableShort", "N/A");
    switch (key) {
      case "index":
        return item.index || notAvailable;
      case "personnel":
        return item.labels?.[0] || notAvailable;
      case "store":
        return item.storeName || notAvailable;
      case "count":
        return item.data?.[0] || 0;
      case "revenue":
        return item.totalRevenue || "₺0";
      default:
        return notAvailable;
    }
  };
  const tableColumns = [
    "#",
    t("extendedWarranty.reports.personnel.name", "Personel"),
    t("extendedWarranty.reports.personnel.store", "Mağaza"),
    t("extendedWarranty.reports.personnel.count", "Adet"),
    t("extendedWarranty.reports.personnel.revenue", "Ciro"),
  ];

  const renderRow = (person, index) => (
    <TableRow key={index}>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{person.labels?.[0] || "N/A"}</TableCell>
      <TableCell>{person.storeName || "N/A"}</TableCell>
      <TableCell>{person.data?.[0] || 0}</TableCell>
      <TableCell>{person.totalRevenue || "₺0"}</TableCell>
    </TableRow>
  );

  return (
    <div className="rounded-lg border bg-white">
      <div className="border-b p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium text-[#111729]">
              {t(
                "extendedWarranty.reports.personnel.title",
                "Personel Performansı",
              )}
            </h3>
            <p className="mt-1 text-sm text-[#677389]">
              {t(
                "extendedWarranty.reports.personnel.description",
                "En çok satış yapan ilk 10 personel",
              )}
            </p>
          </div>
          {data && data.length > 10 && (
            <SortableSearchableTableDialog
              data={data}
              columns={columns}
              title={t(
                "extendedWarranty.reports.personnel.dialogTitle",
                "Personel Performansı - Tüm Veriler",
              )}
              searchPlaceholder={t(
                "extendedWarranty.reports.personnel.searchPlaceholder",
                "Personel, mağaza, adet veya ciro ara...",
              )}
              onSearch={handleSearch}
              onSort={handleSort}
              renderCell={renderCell}
              isOpen={isDialogOpen}
              onOpenChange={setIsDialogOpen}
            />
          )}
        </div>
      </div>
      <ReportTable
        data={displayData}
        loading={loading}
        columns={tableColumns}
        renderRow={renderRow}
        colSpan={4}
      />
    </div>
  );
};

export default PersonnelPerformanceTable;
